import Alert from "./Alert";
import Card2Icon from "./Card2Icon";

function Section04({ config }) {
  return (
    <div
      id="tabs-with-card-4"
      className="hidden"
      role="tabpanel"
      aria-labelledby="tabs-with-card-item-4"
    >
      <div className="bg-white rounded max-w-3xl px-4 pt-6 lg:pt-10 pb-12 sm:px-6 lg:px-8 mx-auto min-h-[57vh]">
        <div className="max-w-2xl">
          <div className="space-y-5 md:space-y-8">
            {config.show_section_title && (
              <div className="max-w-2xl mx-auto mb-10 lg:mb-14">
                <h2 className="flex items-center text-2xl font-bold md:text-4xl md:leading-tight">
                  <div className="mr-4">
                    <Card2Icon sizeNum="3.5" />
                  </div>
                  資格確認書で確認
                </h2>
              </div>
            )}

            <p className="text-lg text-gray-800">
              「資格確認書」はカード型、はがき型、A4型の３種類があります。ご加入の健康保険組合によって様式が異なりますが、記載内容は現行の保険証とほぼ同じです。
            </p>

            <div className="space-y-8">
              <h3 className="text-2xl font-semibold mt-16">
                カード型の資格確認書の例
              </h3>
            </div>

            <figure className="flex flex-col justify-center items-center">
              <img
                className="w-full object-cover shadow-lg p-4"
                src={`${process.env.PUBLIC_URL}/images/shikakukakuninsho-sample.png`}
                alt="カード型の資格確認書のサンプル(厚生労働省国民向けパンフレットより一部改変して掲載)"
                loading="lazy"
              />
              <figcaption className="mt-3 text-sm text-center text-gray-500">
              「資格確認書 国民向けリーフレット（厚生労働省）」の掲載の画像を一部改変して作成。
              </figcaption>
            </figure>

            <div className="hidden space-y-8">
              <h3 className="text-2xl font-semibold mt-16">
                はがき型
              </h3>
            </div>

            <figure className="hidden flex flex-col justify-center items-center">
              <img
                className="w-full object-cover shadow-lg p-4"
                src={`${process.env.PUBLIC_URL}/images/commingsoon.jpg`}
                alt="カード型の資格確認書のサンプル"
                loading="lazy"
              />
              <figcaption className="mt-3 text-sm text-center text-gray-500">
                （準備中）
              </figcaption>
            </figure>

            <div className="hidden space-y-8">
              <h3 className="text-2xl font-semibold mt-16">
                Ａ４型
              </h3>
            </div>

            <figure className="hidden flex flex-col justify-center items-center">
              <img
                className="w-full object-cover shadow-lg p-4"
                src={`${process.env.PUBLIC_URL}/images/commingsoon.jpg`}
                alt="カード型の資格確認書のサンプル"
                loading="lazy"
              />
              <figcaption className="mt-3 text-sm text-center text-gray-500">
                （準備中）
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section04;
